'use strict'
import { request } from '../../plugins/http'

export default async (clientId) => {
    return await request.get('/cliente',{params:{type:'id', value:clientId}})
}